import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CCreateEntreprise } from '@core/models/entreprise';
import { contactintrouvable, emailSended } from '@core/models/messages';
import { ContactService } from '@core/services/contact/contact.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contacter-responsable',
  templateUrl: './contacter-responsable.component.html',
  styleUrls: ['./contacter-responsable.component.css']
})
export class ContacterResponsableComponent {
  contactEsnForm!: FormGroup;
  currentUser: any;
  id: any;
  filtered: any;
  submitted = false;

  types = [
    { value: 'Technique', id: '1' },
    { value: 'Service client', id: '2' },
    { value: 'Réclamation', id: '3' },
  ];

  selected: any = this.types[0];
  file: any;
  idResponsable: any;
  constructor(
    private contactService: ContactService,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private reCaptchaService: ReCaptchaService,
  ) {
    this.currentUser = new CCreateEntreprise();
  }

  ngOnInit() {
    this.currentUser = this.localStorageService.getData('dataUser');
    // this.id = JSON.parse(this.currentUser).id
    this.getId();
    this.contactEsnFormGroup();
  }

  /* get id esn */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idResponsable = params.params['idResponsable'];
      },
    });
  }

  contactEsnFormGroup() {
    this.contactEsnForm = this.formBuilder.group({
      type: [''],
      object: ['', [Validators.required, Validators.maxLength(100)]],
      subject: ['', Validators.required],
      user_id: [''],
      esn_id: this.idResponsable,

      file: [''],
    });
  }

  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.file = file;
      this.contactEsnForm.get('file')?.setValue(this.file);
    }
  }

  contactEsn() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.contactEsnForm.invalid) {
      return;
    }
    this.reCaptchaService.executeAction('contactEsn').then(token => {
      this.spinner.show();
      this.contactEsnForm.get('user_id')?.setValue(this.id);
      console.log('contactForm', this.contactEsnForm.value);

      const formData = new FormData();
      formData.append('type', this.contactEsnForm.get('type')?.value);
      formData.append('object', this.contactEsnForm.get('object')?.value);
      formData.append('subject', this.contactEsnForm.get('subject')?.value);
      // formData.append('user_id', this.id);
      formData.append('id', this.contactEsnForm.get('esn_id')?.value);
      formData.append('recaptchaToken', token);
      // formData.append('file', this.contactEsnForm.get('file')?.value);

      const formDataObject: { [key: string]: any } = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      this.contactService
        .contactResponsable(formData)
        .pipe()
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(emailSended);
            this.onReset();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(contactintrouvable);
            }
          },
        });
        }).catch(err => {
          this.spinner.hide();
          this.toastrService.error('reCAPTCHA verification failed. Please try again.');
        });
  }

  get f() {
    return this.contactEsnForm.controls;
  }

  onSelectChange(event: any) {
    console.log('Selected:', event);
  }

  onReset() {
    this.submitted = false;
    this.contactEsnForm.reset({
      type: '',
      esn_id: this.idResponsable,
      user_id: this.id,
    });
    this.contactEsnForm.get('file')?.setValue('');
    this.contactEsnForm.get('type')?.setValue('');
  }



}
